export default "__VITE_ASSET__a6ced1ff__"